import React from "react";
import { Link } from "react-router-dom";
import { CDN_BASE_URL } from "../../../config";

const BlogCardImage = ({ data }) => {
  return (
    <Link to={"/blogs/" + data?.url} className="relative">
      <img
        src={CDN_BASE_URL + data?.cover}
        className="w-full rounded-[10px] h-[200px]"
        alt=""
      />
      <div className="absolute w-full bottom-0 right-0 p-3 bg_gradiant text-white text-[700] text-[20px]">
        {data?.name}
      </div>
    </Link>
  );
};

export default BlogCardImage;
